import React, { useMemo } from 'react';
import { Flex, Text, Box, RadioGroup } from '@spothero/ui';
import FormatUtils from 'utils/format';
import { Controller, } from 'react-hook-form';
import BorderedRadio from 'common/bordered-radio';
import { useDefaultCard } from 'common/payment-picker/use-payment-form';
import { getCardInitials } from 'utils/payment-utils';
import { PAYPAL_WALLET_VALUE } from 'utils/user-utils';
export const REFUND_CREDIT_VALUE = 'SpotHero Credit';
export const REFUND_ORIGINAL_PAYMENT_METHOD_VALUE = 'Original Payment Method';
export const REFUND_COMBINATION_VALUE = 'Combination';
export const textStyle = {
    fontSize: 'sm',
    lineHeight: '1.4',
    color: 'text.secondary.light',
};
const ReservationRefund = ({ handleSubmit, reservation, control, fieldId, formId, register, onlyCredit = false, onlyOriginalPayment = false, }) => {
    const { creditCard: reservationCreditCard, spotheroCreditUsed, priceBreakdown: { totalPrice }, currencyType, } = reservation;
    const defaultCard = useDefaultCard();
    const refundCard = reservationCreditCard
        ? reservationCreditCard
        : defaultCard;
    const isComboRefund = spotheroCreditUsed > 0 && spotheroCreditUsed < totalPrice;
    const refundMessage = reservation.partner
        ? 'It may take up to 21 business days to appear on payment accounts.'
        : 'It typically takes 5-10 business days for refunds to appear on your payment method.';
    const cardDisplay = useMemo(() => {
        if (!refundCard) {
            return null;
        }
        if (refundCard?.wallet === PAYPAL_WALLET_VALUE) {
            // @ts-expect-error - need to winnow
            return `Paypal ${refundCard.paypalEmail}`;
        }
        else {
            // @ts-expect-error - need to winnow
            const cardTypeFormatted = FormatUtils.slugify(refundCard.type);
            return (<>
                    {getCardInitials(cardTypeFormatted)}
                    <sup>*</sup>
                    {/* @ts-expect-error - need to winnow */}
                    {refundCard.last4}
                </>);
        }
    }, [refundCard]);
    if (onlyOriginalPayment) {
        return (<Flex data-testid="ReservationRefund" width="100%" flexDirection="column">
                <Box as="form" onSubmit={handleSubmit} id={formId}>
                    <input {...register(fieldId, {
            shouldUnregister: true,
            value: REFUND_ORIGINAL_PAYMENT_METHOD_VALUE,
        })} type="hidden"/>
                </Box>
                <Text fontSize="sm">
                    Your refund will be sent to your original payment method.{' '}
                    {refundMessage}
                </Text>
            </Flex>);
    }
    if (onlyCredit) {
        return (<Flex data-testid="ReservationRefund" width="100%" flexDirection="column">
                <Box as="form" onSubmit={handleSubmit} id={formId}>
                    <input {...register(fieldId, {
            shouldUnregister: true,
            value: REFUND_CREDIT_VALUE,
        })} type="hidden"/>
                </Box>
                <Text fontSize="sm">
                    Your reservation was made using SpotHero Credit. Once you
                    submit the cancellation, the credit will be added back to
                    your account instantly.
                </Text>
            </Flex>);
    }
    return (<Flex data-testid="ReservationRefund" width="100%" flexDirection="column">
            <Box as="form" sx={{
            '.chakra-form-control': {
                paddingX: 0,
                marginX: 0,
                paddingTop: 0,
            },
            '.chakra-form__label': {
                fontWeight: 'semibold',
                color: 'black',
                fontSize: 'base',
                paddingTop: 6,
                paddingBottom: 4,
            },
        }} onSubmit={handleSubmit} id={formId}>
                {isComboRefund && (<Box>
                        The {FormatUtils.currencySymbol(currencyType)}
                        {FormatUtils.price(spotheroCreditUsed).displayPrice} you
                        paid in SpotHero Credit will be added back to your
                        account.
                    </Box>)}
                <Controller name={fieldId} control={control} render={({ field }) => (<RadioGroup sx={{
                '.chakra-radio__control': {
                    marginTop: 0.5,
                },
                '.chakra-radio__label': {
                    overflow: 'hidden',
                },
                '.chakra-stack div:not(:first-child)': {
                    marginTop: 3,
                },
            }} marginBottom={4} label={isComboRefund
                ? 'Where should we send the rest of your refund?'
                : 'Where should we send your refund?'} id={fieldId} {...field}>
                            <BorderedRadio isSelected={field.value === REFUND_CREDIT_VALUE} value={REFUND_CREDIT_VALUE} radioStyles={{
                paddingY: 3,
                height: 'auto',
            }}>
                                <Text data-testid="ReservationRefund-text-credit" marginBottom={1}>
                                    SpotHero Credit
                                </Text>
                                <Text color="text.secondary.light">
                                    Credit will be issued immediately
                                </Text>
                            </BorderedRadio>
                            <BorderedRadio isSelected={field.value ===
                REFUND_ORIGINAL_PAYMENT_METHOD_VALUE} value={REFUND_ORIGINAL_PAYMENT_METHOD_VALUE} radioStyles={{
                paddingY: 3,
                height: 'auto',
            }}>
                                <Text marginBottom={1} data-testid="ReservationRefund-text-original-payment">
                                    {refundCard
                ? cardDisplay
                : 'Original Payment Method'}
                                </Text>
                                <Text color="text.secondary.light">
                                    {refundMessage}
                                </Text>
                            </BorderedRadio>
                        </RadioGroup>)}/>
            </Box>
        </Flex>);
};
export default ReservationRefund;
